import rehypeStringify from 'rehype-stringify';
import remarkParse from 'remark-parse';
import remarkRehype from 'remark-rehype';
import remarkGfm from 'remark-gfm';
import {unified} from 'unified';
import {useEffect, useState} from "react";

const useGfmToHtml = (text: string) => {

    const markdown = async (markdown: string) => {
        const escapedMarkdown = markdown.replace(/^(\d+)\.\s/gm, '$1\\. ');
        const file = await unified()
            .use(remarkParse) // Parse markdown content to a syntax tree
            .use(remarkGfm) // Add support for GFM features (tables, tasklists, etc.)
            .use(remarkRehype) // Transform markdown syntax tree to HTML syntax tree
            .use(rehypeStringify) // Serialize HTML syntax tree to an HTML string
            .process(escapedMarkdown);
        return String(file);
    }

    const [displayText, setDisplayText] = useState<string>("");
    useEffect(() => {
        markdown(text).then(result => {
            setDisplayText(result.replace(/^<p>/i, "<span>").replace(/<\/p>$/i, "</span>"));
        });
    }, [text]);
    return displayText;
}

export default useGfmToHtml;